<div class="panel-comment">
  <!-- comment header -->
  <div class="panel-comment__header">
    <!-- comment source title -->
    <p>
      {{ 'profile.comments.productName' | translate }} :
      @if (commentData()?.source && commentData()?.source !== 'PRODUCT') {
        <span class="text-primary-dark">{{
          commentData()?.product?.title | translateData
        }}</span>
      } @else {
        <span class="text-primary-dark">{{
          commentData().product?.title | translateData
        }}</span>
      }
      <!-- comment code -->
      <span class="text-primary-dark"> ({{ commentData().code }})</span>
    </p>

    <!-- comment answers -->
    @if (commentData()?.source && commentData()?.source !== 'PRODUCT') {
      <a
        routerLink="/products/{{ commentData()?.product?._id }}"
        fragment="comments">
        <pwj-button type="button">
          {{ 'profile.comments.view' | translate }}
          <!-- {{ commentData().answersCount }} -->
          {{ 'profile.comments.answers' | translate }}</pwj-button
        >
      </a>
    } @else {
      <a
        routerLink="/products/{{ commentData().product?._id }}"
        fragment="comments">
        <pwj-button type="button">
          {{ 'profile.comments.view' | translate }}
          <!-- {{ commentData().answersCount }} -->
          {{ 'profile.comments.answers' | translate }}</pwj-button
        >
      </a>
    }
  </div>

  <!-- comment content -->
  <p class="panel-comment__body">
    {{ commentData().text }}
  </p>

  <!-- comment footer -->
  <div class="panel-comment__footer">
    <div class="panel-comment__details">
      <!-- comment date -->
      <p class="details-date">
        {{ 'profile.comments.commentDate' | translate }} :

        @if (currentLang === 'fa') {
          <span>
            {{
              commentData().created_at || '' | persianDate: 'jD / jM / jYYYY'
            }}
          </span>
        } @else {
          <span>
            {{ commentData().created_at | date: 'dd/MM/y' }}
          </span>
        }
      </p>

      <!-- comment status -->
      @switch (commentData().status) {
        @case (commentStatusEnum.Approved) {
          <p class="details-state details-state--accepted">
            <i class="iconsax" icon-name="tick-circle"></i>
            <span>{{
              'enums.commentsStatus.' + commentData().status | translate
            }}</span>
          </p>
        }

        @case (commentStatusEnum.Rejected) {
          <p class="details-state details-state--rejected">
            <i class="iconsax" icon-name="x-square"></i>
            <span>{{
              'enums.commentsStatus.' + commentData().status | translate
            }}</span>
          </p>
        }

        @case (commentStatusEnum.Pending) {
          <p class="details-state details-state--waiting">
            <i class="iconsax" icon-name="minus"></i>
            <span>{{
              'enums.commentsStatus.' + commentData().status | translate
            }}</span>
          </p>
        }
      }
    </div>

    <div class="panel-comment__btns">
      <!-- delete comment button -->
      <pwj-button
        variant="secondary"
        size="large"
        icon="chevron-right"
        [rotateIconInRtl]="true"
        [iconReversePosition]="true"
        (click)="onDeleteComment(commentData()._id)">
        {{ 'profile.comments.deleteComment' | translate }}
      </pwj-button>

      <!-- see comment source -->
      @if (commentData()?.source && commentData()?.source !== 'PRODUCT') {
        <a routerLink="/products/{{ commentData().product?._id }}">
          <pwj-button
            variant="primary"
            size="large"
            icon="chevron-right"
            [rotateIconInRtl]="true"
            [iconReversePosition]="true">
            {{ 'profile.comments.seeProduct' | translate }}
          </pwj-button>
        </a>
      } @else {
        <a routerLink="/products/{{ commentData().product?._id }}">
          <pwj-button
            variant="primary"
            size="large"
            icon="chevron-right"
            [rotateIconInRtl]="true"
            [iconReversePosition]="true">
            {{ 'profile.comments.seeProduct' | translate }}
          </pwj-button>
        </a>
      }
    </div>
  </div>
</div>
